import React from 'react'
import Grid from '@material-ui/core/Grid'

import ViewMode from './ViewMode'
import EditMode from './EditMode'
import { ITank } from 'types'

interface Props {
  canSave: boolean
  editMode: boolean
  editModeSensor: boolean
  onCancel: () => void
  onSave: () => void
  onEdit: () => void
  onInputChange: (
    prop: string
  ) => (
      evt:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => void
  onCheckboxChange: (
    prop: string
  ) => (
      evt: React.ChangeEvent<HTMLInputElement>
    ) => void
  device: ITank,
  materialCodes:any,
  materialName : string
}

const DeviceInfo = ({
  canSave,
  device,
  materialCodes,
  materialName,
  editMode,
  editModeSensor,
  onInputChange,
  onCheckboxChange,
  onEdit,
  onCancel,
  onSave
}: Props): React.ReactElement => (
    <Grid container direction="column">
      {(!editMode && !editModeSensor) && (
        <Grid container item justify="flex-end">
          <img className="clickable" src="/images/icons/edit.svg" onClick={onEdit} />
        </Grid>
      )}
      {!editMode && <ViewMode device={device} materialName={materialName} />}
      {editMode && (
        <EditMode
          device={device}
          materialCodes={materialCodes}
          materialName={materialName}
          canSave={canSave}
          onCancel={onCancel}
          onSave={onSave}
          onInputChange={onInputChange}
          onCheckboxChange={onCheckboxChange}
        />
      )}
    </Grid>
  )

export default DeviceInfo
